import '.d{display:flex;}.ssr-plugin'
import '.a9{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.a7{background-color:var(--palette-blue-50);}.ssr-plugin'
import '.dk{color:var(--palette-blue-300);}.ssr-plugin'
import '.e9{border-radius:0.5rem;}.ssr-plugin'
import '.he{width:2rem;}.ssr-plugin'
import '.b7{height:2rem;}.ssr-plugin'
import '.b1{aspect-ratio:1/1;}.ssr-plugin'
import { Text } from '../typography/Text'
import { IconButton } from '../button/IconButton'
import {
  faXmark,
  faFile,
  faImage,
  faCircleNotch,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Image } from '../image/Image'

export type FileDisplayProps = {
  type: 'document' | 'image'
  name: string
  src?: string
  onRemove?: VoidFunction
  isLoading?: boolean
}

const iconVariant: Record<FileDisplayProps['type'], IconDefinition> = {
  image: faImage,
  document: faFile,
}

const fileDisplayStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.5rem',
  border: 'var(--border-subtle)',
  backgroundColor: 'var(--palette-white)',
  boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.05)',
  borderRadius: '0.625rem',
  textDecoration: 'none',
  color: 'inherit',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'var(--gray-100)',
  },
}

export const FileDisplay = ({
  type,
  name,
  src,
  onRemove,
  isLoading = false,
}: FileDisplayProps) => {
  const content = (
    <>
      {type === 'image' && src && !isLoading ? (
        <Image
          src={src}
          alt={name}
          resizeWidth={32}
          style={{
            width: '2rem',
            height: '2rem',
            objectFit: 'cover',
            borderRadius: '0.5rem',
          }}
        />
      ) : (
        <div className="d a9 r a7 dk e9 he b7 b1"
        >
          {isLoading ? (
            <FontAwesomeIcon
              icon={faCircleNotch}
              spin
              style={{ fontSize: '1rem' }}
            />
          ) : (
            <FontAwesomeIcon icon={iconVariant[type]} />
          )}
        </div>
      )}
      <Text.Small
        isBold
        style={{
          textWrap: 'nowrap',
          overflow: 'hidden',
          maxWidth: '7rem',
          textOverflow: 'ellipsis',
        }}
      >
        {name}
      </Text.Small>
    </>
  )

  if (src) {
    return (
      <styled.a
        href={src}
        download={name}
        style={fileDisplayStyle}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
          if (onRemove) {
            e.stopPropagation()
          }
        }}
      >
        {content}
        {onRemove && !isLoading && (
          <div className="d r"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault()
              e.stopPropagation()
              onRemove()
            }}
          >
            <IconButton
              size="small"
              variant="transparent"
              icon={faXmark}
              onClick={() => {}}
              style={{
                border: 0,
                width: '1rem',
                height: '1rem',
              }}
            />
          </div>
        )}
      </styled.a>
    )
  }

  return (
    <styled.div style={fileDisplayStyle}>
      {content}
      {onRemove && !isLoading && (
        <IconButton
          size="small"
          variant="transparent"
          icon={faXmark}
          onClick={onRemove}
          style={{
            border: 0,
            width: '1rem',
            height: '1rem',
          }}
        />
      )}
    </styled.div>
  )
}
